export class l {
  getOptions() {
    return {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric'
    };
  }
}


/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/core/i18n/date/MonthDayYear2Digit.js
 **/